import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { standardStyles } from "@components/suggestion-card-header/SuggestionCardHeader.styles";

const { container, body, topLine } = standardStyles;
export { container, body, topLine };

export const headerBody: CSSProperties = {
  ...body,
  paddingBottom: 15,
  borderBottom: container.borderBottom,
};
